import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const embellishmentEndPoints = {
  EMB_LANDING_COUNT: 'EMB_LANDING_COUNT',
  EMB_SENT_CREATE: 'EMB_SENT_CREATE',
  EMB_RECEIVE_CREATE: 'EMB_RECEIVE_CREATE',
  EMB_RECEIVE_UPDATE: 'EMB_RECEIVE_UPDATE',
  EMB_REMOVE_TAG: 'EMB_REMOVE_TAG',
  EMB_REMOVE_TRANSACTION: 'EMB_REMOVE_TRANSACTION',
  EMB_LOG_LISTING: 'EMB_LOG_LISTING',
  EMB_LOG_LISTING_DETAILS: 'EMB_LOG_LISTING_DETAILS',
  EMB_SENT_TAG_DETAILS: 'EMB_SENT_TAG_DETAILS',
  EMB_GET_COMPONENT_TAG_DETAILS: 'EMB_GET_COMPONENT_TAG_DETAILS',
  EMB_RECEIVE_GET_DEFECTIVES: 'EMB_RECEIVE_GET_DEFECTIVES',
  EMB_RECEIVE_UPDATE_DEFECTIVES: 'EMB_RECEIVE_UPDATE_DEFECTIVES',
};

type TEmbellishmentEndPoints = typeof embellishmentEndPoints;
type TEmbellishmentEndPointsTypes = keyof TEmbellishmentEndPoints;
type TEnvVariables = TEmbellishmentEndPoints;

@Injectable({
  providedIn: 'root',
})
export class EmbellishmentEnvService {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private tags_services = '';

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol != null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host != null) {
      this.service_host = ENV.service_host;
    }
    if (ENV.tags_services !== null) {
      this.tags_services = ENV.tags_services;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    const TAGS_SERVICE_URL = HOST_DOMAIN_WITH_PROTOCOL + this.tags_services;
    this.env_vars = {
      EMB_LANDING_COUNT: `${TAGS_SERVICE_URL}/v1/emb/:embType/pieceCount`,
      EMB_SENT_CREATE: `${TAGS_SERVICE_URL}/v1/emb/sent/create`,
      EMB_RECEIVE_CREATE: `${TAGS_SERVICE_URL}/v1/emb/received/create`,
      EMB_RECEIVE_UPDATE: `${TAGS_SERVICE_URL}/v1/emb/received/update`,
      EMB_REMOVE_TAG: `${TAGS_SERVICE_URL}/v1/emb/:embType/remove/byTagId`,
      EMB_REMOVE_TRANSACTION: `${TAGS_SERVICE_URL}/v1/emb/:embType/remove/byTransactionId`,
      EMB_LOG_LISTING: `${TAGS_SERVICE_URL}/v1/emb/:embType/listing/:listType`,
      EMB_LOG_LISTING_DETAILS: `${TAGS_SERVICE_URL}/v1/emb/:embType/listing/:listType/byId`,
      EMB_SENT_TAG_DETAILS: `${TAGS_SERVICE_URL}/v1/emb/sent/byTagId`,
      EMB_GET_COMPONENT_TAG_DETAILS: `${TAGS_SERVICE_URL}/tags/getComponentTagByDisplayTagId`,
      EMB_RECEIVE_GET_DEFECTIVES: `${TAGS_SERVICE_URL}/v1/received/defectives/list`,
      EMB_RECEIVE_UPDATE_DEFECTIVES: `${TAGS_SERVICE_URL}/v1/emb/received/defectives/update`,
    };
  }

  getEnvVar(key: TEmbellishmentEndPointsTypes): string {
    return this.env_vars[key];
  }
}
